import type { ProjectWithRelations } from "@/hooks/useProjects";

export const UPCOMING_PROJECT_LIMIT = 5;

function toUtcDay(value: string | null | undefined) {
  if (!value) return null;
  const date = new Date(`${value}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return null;
  return date.getTime();
}

export function getUpcomingProjectSortDate(project: ProjectWithRelations) {
  return (
    project.planning_start_date ??
    project.event_start_date ??
    project.start_date ??
    project.planning_end_date ??
    project.event_end_date ??
    project.end_date ??
    null
  );
}

export function isUpcomingProject(
  project: Pick<
    ProjectWithRelations,
    | "planning_start_date"
    | "event_start_date"
    | "start_date"
    | "planning_end_date"
    | "event_end_date"
    | "end_date"
  >,
  todayUtcMs: number,
) {
  const start =
    toUtcDay(project.planning_start_date) ??
    toUtcDay(project.event_start_date) ??
    toUtcDay(project.start_date);
  const end =
    toUtcDay(project.planning_end_date) ??
    toUtcDay(project.event_end_date) ??
    toUtcDay(project.end_date) ??
    start;

  if (start === null && end === null) return false;
  return (end ?? start!) >= todayUtcMs;
}
